var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogosTelegram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_10889)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.95422 0 0 8.95422 0 20C0 31.0458 8.95422 40 20 40C31.0458 40 40 31.0458 40 20C40 8.95422 31.0458 0 20 0Z",
    fill: "#40B3E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7347 11.4959L26.1623 29.5067C26.1623 29.5067 25.6628 30.7558 24.2889 30.1562L16.0455 23.8362L13.048 22.3875L8.00203 20.6887C8.00203 20.6887 7.22766 20.414 7.15266 19.8145C7.07766 19.215 8.02703 18.8903 8.02703 18.8903L28.0858 11.0215C28.0858 11.0215 29.7345 10.2972 29.7345 11.4962",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4109 29.3073C15.4109 29.3073 15.1703 29.2848 14.8703 28.3355C14.5708 27.3862 13.0469 22.3903 13.0469 22.3903L25.1622 14.6966C25.1622 14.6966 25.8617 14.2719 25.8367 14.6966C25.8367 14.6966 25.9616 14.7716 25.5867 15.1212C25.2122 15.4711 16.0695 23.6894 16.0695 23.6894",
    fill: "#D2E5F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2044 26.2659L15.9439 29.2387C15.9439 29.2387 15.6889 29.4322 15.4102 29.3109L16.0345 23.7891",
    fill: "#B5CFE4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_10889"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosTelegram);
export default __webpack_public_path__ + "static/media/logos_telegram.b737495faaa8a25927eb6571d070577d.svg";
export { ForwardRef as ReactComponent };